<!--  -->
<template>
  <div class="container">
     <div class="pic1-panel" v-show="activePage === 0">
        <div class="left-panel">
          <h3>一个线上线下都能学习的孕妇学校</h3>
          <div class="desc-wrapper">
            <p>孕e家小程序，浓缩了app的核心功能，提供了线上孕妇课堂，视频动画、学习班报名等一系列服务。众多知名专家亲自出镜，提供专业保障。生动的动画、真实的案例讲述宝贵的怀孕经验，让新手妈妈不再手忙脚乱。</p>
          </div>
          <div class="qrcode-wrapper">
            <div>
              <img src="../../../../assets/images/img_p3_1_code.png" alt="孕e家二维码">
              <p>扫一扫 马上使用</p>
            </div>

          </div>
        </div>
        <div class="right-panel">
          <img src="../../../../assets/images/img_p3_1_pic.png" alt="截图">
        </div>
     </div>
     <div class="pic2-panel" v-show="activePage === 1">
      <div class="text-panel">
        <h3>伴你孕期每一天</h3>
        <p>我们为准妈们制作了一批精美的视频，从怀孕初期到宝宝出生，各个阶段的注意事项、医学常识、常见误区都应有尽有。不再是枯燥无味的教学，不再有晦涩难懂的专业名词，通俗易懂、贴近生活的动画陪伴你孕期每一天。</p>
      </div>
      <div class="pic-panel">
        <img src="../../../../assets/images/img_p3_2_pic.png" alt="">
      </div>
    </div>
     <div class="pic2-panel" v-show="activePage === 2">
      <div class="pic-panel">
        <img src="../../../../assets/images/img_p3_3_pic.png" alt="">
      </div>
      <div class="text-panel">
        <h3>医院专属孕妇课堂</h3>
        <p>在这里，你能找到各大知名医院专属的孕期精品视频课程，由产科专家亲身讲授；另外，还能预约该院孕妇课堂线下教学班，学习各种护理方法，让你的孕期生活更轻松。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      activePage: 0
    }
  },

  props: [],

  watch: {},

  components: {},

  computed: {},

  created () {},

  methods: {}
}

</script>
<style lang='scss' scoped>
.container {
  width: 100%;
  .pic1-panel {
    padding: 0 410px;
    display: flex;
    justify-content: space-between;
    .left-panel {
     display: inline-block;
     vertical-align: top;
     width: 600px;
     margin-top: 11vh;
     h3 {color: #FF789E; font-size: 30px; line-height: 42px; font-weight: 600; text-align: left; margin-bottom: 13px;}
     .desc-wrapper {
       width:550px;
       p {
         color: #666; font-size: 18px; line-height: 30px; text-align: left;
         a {cursor: pointer;float: right; }
         a:hover {font-weight: 600;text-decoration: none;}
         }
       span { 
         color: #FF789E; font-size: 18px; line-height: 30px;
         display: flex; align-items: center;
         img {margin-left: 2px; width: 18px; height: 18px; }
       }
     }
     .qrcode-wrapper {
        margin: 5vh 0  0 173px;
        text-align: left;
        div {
          width: 204px;
          height: 204px;
          img {
            width: 100%;
            height: 100%;
          }
          p {text-align: center; font-size: 24px; line-height: 33px; color:#FF789E; font-weight: 600;}
        }
     }
    }
    .right-panel {
       display: inline-block;
       vertical-align: top;
       width: 420px;
       height: 660px;
       img {
        width: 100%;
        height: 100%;
       }
    }
  }


   .pic2-panel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    padding: 0 380px;
    height: 100%;
    margin-top: 50px\0;
    .text-panel {
      display: inline-block;
      vertical-align: middle;
      width: 460px;
      text-align: left;
      h3 { color: #FF789E; font-size: 30px; line-height: 42px; font-weight: 600; margin-bottom: 17px;}
      p {color: #666; font-size: 24px; line-height: 38px;}
    }
    .pic-panel {
      display: inline-block;
      vertical-align: middle;;
      width: 610px;
      height: 540px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/pages/index/components/productBox/school.vue